import { render, staticRenderFns } from "./ChangeRemains.vue?vue&type=template&id=4c048bac&scoped=true"
import script from "./ChangeRemains.vue?vue&type=script&lang=js"
export * from "./ChangeRemains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c048bac",
  null
  
)

export default component.exports